export default "__VITE_ASSET__be87b83b__"